export type SuggestedActionMeta = {
  labelKey: string;
  icon?: string;
  buttonFill?: 'outline' | 'solid';
  color?: string;
};

/**
 * Display metadata for each known suggested action.
 * To add a new action: extend this record + add a handler in chat.page.ts.
 */
export const SUGGESTED_ACTION_REGISTRY: Record<string, SuggestedActionMeta> = {
  createCharacter: {
    labelKey: 'chat.suggestedAction.createCharacter',
    icon: 'person-add-outline',
    buttonFill: 'solid',
    color: 'secondary',
  },
  restShort: {
    labelKey: 'chat.suggestedAction.restShort',
    icon: 'cafe-outline',
    buttonFill: 'outline',
  },
  restLong: {
    labelKey: 'chat.suggestedAction.restLong',
    icon: 'moon-outline',
    buttonFill: 'outline',
  },
};
